/* eslint-disable no-use-before-define */
import React, {
  useRef, useState, forwardRef, useImperativeHandle
} from 'react';
import { UserAddOutlined } from '@ant-design/icons';
import { Button, Tabs } from 'antd';
import UserDetails from '../users/UserDetails';
import UsersList from '../users/UsersList';

const Users = forwardRef((props, ref) => {
  const newTabIndex = useRef(0);

  const defaultPanes = [
    {
      key: 'usersList',
      label: 'Users List',
      children: <UsersList add={addUserTab} />,
      closable: false
    }
  ];

  const [items, setItems] = useState(defaultPanes);
  const [activeKey, setActiveKey] = useState(defaultPanes[0].key);

  function addUserTab(id, name) {
    const newKey = `user_${id}_${newTabIndex.current++}`;

    setItems((prev) => [
      ...prev,
      {
        key: newKey,
        label: name || 'User Details',
        children: <UserDetails id={id} />,
        closable: true
      }
    ]);

    setActiveKey(newKey);
  }

  // Expose la fonction via ref
  useImperativeHandle(ref, () => ({
    addUserTab
  }));

  const addNewUser = () => {
    const url = 'https://josiayvan.github.io/emia_form';
    window.open(url, '_blank');
  };

  const removeTab = (targetKey) => {
    const newPanes = items.filter((p) => p.key !== targetKey);
    setItems(newPanes);

    if (activeKey === targetKey && newPanes.length) {
      setActiveKey(newPanes[newPanes.length - 1].key);
    }
  };

  const onEdit = (targetKey, action) => {
    if (action === 'remove') {
      removeTab(targetKey);
    }
  };

  return (
    <Tabs
      activeKey={activeKey}
      type='editable-card'
      onChange={setActiveKey}
      onEdit={onEdit}
      items={items}
      size='large'
      hideAdd
      tabBarExtraContent={(
        <Button
          icon={<UserAddOutlined />}
          onClick={addNewUser}
          type='primary'
          size='large'
        >
          Create User
        </Button>
      )}
    />
  );
});

export default React.memo(Users);
